(function() {

	var searchParams = new URLSearchParams( window.location.search );

	var validateForm = function() {

		let status = true;

		$( '.js-date-input' ).each( function() {

			const isValid = $( this )[ 0 ].checkValidity();

			if( !isValid ) {

				status = false;

			}

		});

		return status;

	};

	var defineProductObject = function( type, id, quantity, timeStamp, formData ) {

		var product;

		if( type === 'tapes' ) {

			product = {
				id : id,
				quantity : quantity,
				properties : {
					data : {
						'name': 'inputs',
						'value': {
							'type': type,
							'usb_copies' : 0,
							'dvd_copies': 0,
							'dvd_options': {
								theme: null,
								music: null
							},
							'title': null,    // ignored for tape, since we use customizations for each tape
							'quantity': quantity,   // must match number if elements in customizations array
							'customizations': []
						}
					},
					timeStamp : {
						'date' : timeStamp
					},
					additional : {
						'estimate' : {
							'total' : parseInt( formData.find( function( item ){ return item.name === 'properties[estimated-total]' } ).value ) || null
						}
					},
					upsells : {
						'dvd' : {
							'id' : null,
							'quantity' : 0
						}
					}
				}
			};

		} else if ( type === 'digital_media' ) {

			product = {
				id : id,
				quantity : quantity,
				properties : {
					data : {
						'name': 'inputs',
						'value': {
							'type': type,
							'dvd_copies': 0,
							'dvd_options': {
								theme: null,
								music: null
							},
							'title': null,    // ignored for tape, since we use customizations for each tape
							'quantity': quantity,   // must match number if elements in customizations array
							'customizations': []
						}
					},
					timeStamp : {
						'date' : timeStamp
					},
					additional : {
						'estimate' : {
							'total' : parseInt( formData.find( function( item ){ return item.name === 'properties[estimated-total]' } ).value ) || null
						}
					},
					upsells : {
						'dvd' : {
							'id' : null,
							'quantity' : 0
						}
					}
				}
			};

		} else if( type === 'photos' ) {

			product = {
				id : formData.find( function( item ){ return item.name === 'id' } ).value,
				quantity : 1,
				properties : {
					data : {
						'name': 'inputs',
						'value': {
							'type': 'images',
							'dvd_copies': 0,
							'dvd_options': {
								theme: null,
								music: null
							},
							'title': null,    // title for this transfer no matter how many reels.
							'quantity': quantity,              // should be combined quantity of all reel sizes
							"customizations": []

						}
					},
					timeStamp : {
						'date' : timeStamp
					},
					additional : {
						'type' : 'photos',
						'additional-products' : [
							{
								'id' : parseInt( formData.find( function( item ){ return item.name === 'extra' } ).value ) || null,
								'quantity' : quantity > 50 ? quantity - 50 : 0,
								'total' : parseInt( formData.find( function( item ){ return item.name === 'properties[estimated-additional-total]' } ).value ) || null
							}
						],
						'estimate' : {
							'total' : parseInt( formData.find( function( item ){ return item.name === 'properties[estimated-total]' } ).value ) || null
						}
					},
					upsells : {
						'dvd' : {
							'id' : null,
							'quantity' : 0
						}
					}
				}
			};

		} else if ( type === 'slides' ) {

			product = {
				id : formData.find( function( item ){ return item.name === 'id' } ).value,
				quantity : 1,
				properties : {
					data : {
						'name': 'inputs',
						'value': {
							'type': 'images',
							'dvd_copies': 0,
							'dvd_options': {
								theme: null,
								music: null
							},
							'title': null,    // title for this transfer no matter how many reels.
							'quantity': quantity,              // should be combined quantity of all reel sizes
							"customizations": []

						}
					},
					timeStamp : {
						'date' : timeStamp
					},
					additional : {
						'type' : 'slides',
						'additional-products' : [
							{
								'id' : parseInt( formData.find( function( item ){ return item.name === 'extra' } ).value ) || null,
								'quantity' : quantity > 50 ? quantity - 50 : 0,
								'total' : parseInt( formData.find( function( item ){ return item.name === 'properties[estimated-additional-total]' } ).value ) || null
							}
						],
						'estimate' : {
							'total' : parseInt( formData.find( function( item ){ return item.name === 'properties[estimated-total]' } ).value ) || null
						}
					},
					upsells : {
						'dvd' : {
							'id' : null,
							'quantity' : 0
						}
					}
				}
			};

		} else if ( type === 'negatives' ) {

			product = {
				id : formData.find( function( item ){ return item.name === 'id' } ).value,
				quantity : 1,
				properties : {
					data : {
						'name': 'inputs',
						'value': {
							'type': 'images',
							'dvd_copies': 0,
							'dvd_options': {
								theme: null,
								music: null
							},
							'title': null,    // title for this transfer no matter how many reels.
							'quantity': quantity,              // should be combined quantity of all reel sizes
							"customizations": []

						}
					},
					timeStamp : {
						'date' : timeStamp
					},
					additional : {
						'type' : 'negatives',
						'additional-products' : [
							{
								'id' : parseInt( formData.find( function( item ){ return item.name === 'extra' } ).value ) || null,
								'quantity' : quantity > 50 ? quantity - 50 : 0,
								'total' : parseInt( formData.find( function( item ){ return item.name === 'properties[estimated-additional-total]' } ).value ) || null
							}
						],
						'estimate' : {
							'total' : parseInt( formData.find( function( item ){ return item.name === 'properties[estimated-total]' } ).value ) || null
						}
					},
					upsells : {
						'dvd' : {
							'id' : null,
							'quantity' : 0
						}
					}
				}
			};

		} else if ( type === 'films' ) {

			product = {
				id : formData.find( function( item ){ return item.name === 'id' } ).value,
				quantity : 1,
				properties : {
					data : {
						'name': 'inputs',
						'value': {
							'type': type, // needs to be 'films' for film reels
							'dvd_copies': 0,
							'dvd_options': {
								theme: null,
								music: null
							},
							'title': null,    // title for this transfer no matter how many reels.
							'quantity': quantity, // should be combined quantity of all reel sizes
							'actual_audio' : false, // is actual audio
							'media_date': null, // media date for this transfer
							'customizations': []
						}
					},
					timeStamp : {
						'date' : timeStamp
					},
					additional : {
						'id' : parseInt( formData.find( function( item ){ return item.name === 'extra' } ).value ) || null,
						'quantity' : 0,
						'reels' : 0,
						'estimate' : {
							'total' : parseInt( formData.find( function( item ){ return item.name === 'properties[estimated-total]' } ).value ) || null
						},
						'total' : parseInt( formData.find( function( item ){ return item.name === 'properties[estimated-additional-total]' } ).value ) || null
					},
					upsells : {
						'dvd' : {
							'id' : null,
							'quantity' : 0
						}
					}
				}
			};

		} else if ( type === 'albums' || type === 'album_scan') {
            // alert(JSON.stringify(formData));
			product = {
				id : id,
				quantity : quantity,
				properties : {
					data : {
						'name': 'inputs',
						'value': {
							'type': 'album_scan',
							'usb_copies' : 0,
							'dvd_copies': 0,
							'dvd_options': {
								theme: null,
								music: null
							},
							'quantity': 0,   // must match number of photos for each album
                            'extra_quantity': 0,
							'customizations': [],
							'line_items': []
						}
					},
					timeStamp : {
						'date' : timeStamp
					},
					additional : {
						'type' : 'album_scan',
						'additional-products' : [
							{
								'id' : parseInt( formData.find( function( item ){ return item.name === 'extra' } ).value ) || null,
								'quantity' : quantity > 35 ? quantity - 35 : 0,
								'total' : parseInt( formData.find( function( item ){ return item.name === 'properties[estimated-additional-total]' } ).value ) || null
							}
						],
						'estimate' : {
							'total' : parseInt( formData.find( function( item ){ return item.name === 'properties[estimated-total]' } ).value ) || null
						}
					},
					upsells : {
						'dvd' : {
							'id' : null,
							'quantity' : 0
						}
					}
				}
			};
		}


		return product;

	};

	var submitTransfer = function( type ) {


		var formData = $( '.product-template-form' ).serializeArray();

		// generate timestamp for products
		var timeStamp = new Date();

		// array for storing our products to add to cart
		var cartItems = [];

		var id = formData.find( function( item ){ return item.name === 'id' } ).value;
		var quantity;

		if( type === 'films' ) {

			var three_inch = formData.find( function( item ){ return item.name === 'properties[film_reel][3_feet]' } ).value * 50;
			var four_inch = formData.find( function( item ){ return item.name === 'properties[film_reel][4_feet]' } ).value * 100;
			var five_inch = formData.find( function( item ){ return item.name === 'properties[film_reel][5_feet]' } ).value * 200;
			var six_inch = formData.find( function( item ){ return item.name === 'properties[film_reel][6_feet]' } ).value * 300;
			var seven_inch = formData.find( function( item ){ return item.name === 'properties[film_reel][7_feet]' } ).value * 400;
			var eight_inch = formData.find( function( item ){ return item.name === 'properties[film_reel][8_feet]' } ).value * 600;
			var ten_inch = formData.find( function( item ){ return item.name === 'properties[film_reel][10_feet]' } ).value * 800;
			var quantity = parseInt( three_inch ) + parseInt( four_inch ) + parseInt( five_inch ) + parseInt( six_inch ) + parseInt( seven_inch ) + parseInt( eight_inch ) + parseInt( ten_inch );

		} else {

			quantity = formData.find( function( item ){ return item.name === 'quantity' } )?.value;

		}

		var product = defineProductObject( type, id, quantity, timeStamp, formData );

        if ( type == 'album_scan' ) {


          for ( var i = 0; i < quantity; i++ ){

            let photoQuantity = formData.find( function( item ){ return item.name === 'properties[album][photos_' + (i + 1) + ']' }).value
            let extraQuantity = 0;

            let originalQuantity = parseInt(photoQuantity);

            if ( photoQuantity > 35 ) {

              extraQuantity = photoQuantity - 35;
              photoQuantity = 35;

              // product.properties.additional.estimate.total += (extraQuantity * 29);

              // product.properties.data.value.quantity += photoQuantity;
              product.properties.data.value.quantity += (photoQuantity + extraQuantity);
              product.properties.data.value.extra_quantity += extraQuantity;

			  product.properties.data.value.line_items.push({
				  "sku": "TRX-BLK-C01",
				  "quantity": extraQuantity
			  });


			  cartItems.push({
				id : parseInt( formData.find( function( item ){ return item.name === 'extra' } ).value ) || null,
				quantity : extraQuantity,
				properties : {
					'timeStamp' : {
						'date' : timeStamp,
						'for' : 'Album Transfer ' + ( i + 1 )
					}
				}
			});

            }

            var title = document.getElementsByName('properties[ album-' + i + ' ][ title ]');
            var rewind = document.getElementsByName('properties[ album-' + i + ' ][ rewind ]');
            var year = document.getElementsByName('properties[ album-' + i + ' ][ year ]');
            var month = document.getElementsByName('properties[ album-' + i + ' ][ month ]');
            var day = document.getElementsByName('properties[ album-' + i + ' ][ day ]');


            if( $( year ).val() === '' && $( month ).val() === '' && $( day ).val() === '' ) {

                product.properties.data.value.customizations.push({
                    // 'title' : $( title ).val(),
                    'title' : $(title).val(),
                    'quantity' : originalQuantity,
                    'media_date' : null
                })

            } else {

                product.properties.data.value.customizations.push({
                    // 'title' : $( title ).val(),
                    'title' : $(title).val(),
                    'quantity' : originalQuantity,
                    'media_date' : $( year ).val() + '/' + $( month ).val() + '/' + $( day ).val()
                })

            }

          }

          // console.log(formData.find( function( item ){ return item.name === 'properties[estimated-total]' } ).value);

        } else if ( type == 'tapes' ) {

			for ( var i = 0; i < quantity; i++ ){

				var title = document.getElementsByName('properties[ tape-' + i + ' ][ title ]');
				var rewind = document.getElementsByName('properties[ tape-' + i + ' ][ rewind ]');
				var year = document.getElementsByName('properties[ tape-' + i + ' ][ year ]');
				var month = document.getElementsByName('properties[ tape-' + i + ' ][ month ]');
				var day = document.getElementsByName('properties[ tape-' + i + ' ][ day ]');

				if( $( year ).val() === '' && $( month ).val() === '' && $( day ).val() === '' ) {

					product.properties.data.value.customizations.push({
						'title' : $( title ).val(),
						'rewind' : $( rewind ).val() === 'true' ? true : false,
						'media_date' : null
					})

				} else {

					product.properties.data.value.customizations.push({
						'title' : $( title ).val(),
						'rewind' : $( rewind ).val() === 'true' ? true : false,
						'media_date' : $( year ).val() + '/' + $( month ).val() + '/' + $( day ).val()
					})

				}


			}

		} else if( type == 'digital_media' ) {

			for ( var i = 0; i < quantity; i++ ) {

				var title = document.getElementsByName('properties[ digital-' + i + ' ][ title ]');
				var year = document.getElementsByName('properties[ digital-' + i + ' ][ year ]');
				var month = document.getElementsByName('properties[ digital-' + i + ' ][ month ]');
				var day = document.getElementsByName('properties[ digital-' + i + ' ][ day ]');

				if( $( year ).val() === '' && $( month ).val() === '' && $( day ).val() === '' ) {

					product.properties.data.value.customizations.push({
						'title' : $( title ).val(),
						'media_date' : null
					});

				} else {

					product.properties.data.value.customizations.push({
						'title' : $( title ).val(),
						'media_date' : $( year ).val() + '/' + $( month ).val() + '/' + $( day ).val()
					});

				}

			}

		} else if( type == 'photos' ) {

			// add customizations
			var title = $( 'input[name="properties[title]"]').val();
			var year = $( 'input[name="properties[year]"]').val();
			var month = $( 'input[name="properties[month]"]').val();
			var day = $( 'input[name="properties[day]"]').val();

			product.properties.data.value.title = title;

			if( year === '' && month === '' && day === '' ) {

				product.properties.data.value.customizations.push({
					'sku' : 'TRX-PRT-C80',
					'quantity' : quantity,
					'media_date' : null,
					'title' : title
				});


			} else {

				product.properties.data.value.customizations.push({
					'sku' : 'TRX-PRT-C80',
					'quantity' : quantity,
					'media_date' : year + '/' + month + '/' + day,
					'title' : title
				});

			}

		} else if( type == 'slides' ) {

			// add customizations
			var title = $( 'input[name="properties[title]"]').val();
			var year = $( 'input[name="properties[year]"]').val();
			var month = $( 'input[name="properties[month]"]').val();
			var day = $( 'input[name="properties[day]"]').val();

			product.properties.data.value.title = title;

			if( year === '' && month === '' && day === '' ) {

				product.properties.data.value.customizations.push({
					'sku' : 'TRX-SLD-C80',
					'quantity' : quantity,
					'media_date' : null,
					'title' : title
				});


			} else {

				product.properties.data.value.customizations.push({
					'sku' : 'TRX-SLD-C80',
					'quantity' : quantity,
					'media_date' : year + '/' + month + '/' + day,
					'title' : title
				});

			}

		} else if( type == 'negatives' ) {

			// add customizations
			var title = $( 'input[name="properties[title]"]').val();
			var year = $( 'input[name="properties[year]"]').val();
			var month = $( 'input[name="properties[month]"]').val();
			var day = $( 'input[name="properties[day]"]').val();

			product.properties.data.value.title = title;

			if( year === '' && month === '' && day === '' ) {

				product.properties.data.value.customizations.push({
					'sku' : 'TRX-NEG-C80',
					'quantity' : quantity,
					'media_date' : null,
					'title' : title
				});


			} else {

				product.properties.data.value.customizations.push({
					'sku' : 'TRX-NEG-C80',
					'quantity' : quantity,
					'media_date' : year + '/' + month + '/' + day,
					'title' : title
				});

			}

		} else {

			// add customizations
			var title = $( 'input[name="properties[title]"]').val();
			var year = $( 'input[name="properties[year]"]').val();
			var month = $( 'input[name="properties[month]"]').val();
			var day = $( 'input[name="properties[day]"]').val();

            product.properties.data.value.title = title;

			if( year === '' && month === '' && day === '' ) {

				product.properties.data.value.media_date = null;

			} else {

				product.properties.data.value.media_date = year + '/' + month + '/' + day;

			}

		}

		var additionalProduct;

		if( type === 'photos' ) {

			if( quantity > 50 ) {

				product.properties.data.value.quantity = quantity;

				// //additional product object
				additionalProduct = {
					id : parseInt( formData.find( function( item ){ return item.name === 'extra' } ).value ) || null,
					quantity : ( quantity - 50 ),
					properties : {
						'timeStamp' : {
							'date' : timeStamp
						}
					}
				}

			} else {

				product.properties.data.value.quantity = quantity;

			}

		} else if( type === 'slides' ) {

			if( quantity > 50 ) {

				product.properties.data.value.quantity = quantity;

				// //additional product object
				additionalProduct = {
					id : parseInt( formData.find( function( item ){ return item.name === 'extra' } ).value ) || null,
					quantity : ( quantity - 50 ),
					properties : {
						'timeStamp' : {
							'date' : timeStamp
						}
					}
				}

			} else {

				product.properties.data.value.quantity = quantity;

			}

		} else if( type === 'negatives' ) {

			if( quantity > 50 ) {

				product.properties.data.value.quantity = quantity;

				// //additional product object
				var additionalProduct = {
					id : parseInt( formData.find( function( item ){ return item.name === 'extra' } ).value ) || null,
					quantity : ( quantity - 50 ),
					properties : {
						'timeStamp' : {
							'date' : timeStamp
						}
					}
				}

			} else {

				product.properties.data.value.quantity = quantity;

			}

		} else if ( type === 'films' ) {

			if( quantity > 100 ) {

				product.properties.additional.quantity = quantity - 100
				additionalProduct = {
					id : parseInt( formData.find( function( item ){ return item.name === 'extra' } ).value ) || null,
					quantity : quantity - 100,
					properties : {
						'timeStamp' : {
							'date' : timeStamp
						}
					}
				}

			}

			product.properties.data.value.customizations.push(
				{ 'sku': 'TRX-FLC-S03', 'quantity': formData.find( function( item ){ return item.name === 'properties[film_reel][3_feet]' } ).value },
				{ 'sku': 'TRX-FLC-S04', 'quantity': formData.find( function( item ){ return item.name === 'properties[film_reel][4_feet]' } ).value },
				{ 'sku': 'TRX-FLC-S05', 'quantity': formData.find( function( item ){ return item.name === 'properties[film_reel][5_feet]' } ).value },
				{ 'sku': 'TRX-FLC-S06', 'quantity': formData.find( function( item ){ return item.name === 'properties[film_reel][6_feet]' } ).value },
				{ 'sku': 'TRX-FLC-S07', 'quantity': formData.find( function( item ){ return item.name === 'properties[film_reel][7_feet]' } ).value },
				{ 'sku': 'TRX-FLC-S08', 'quantity': formData.find( function( item ){ return item.name === 'properties[film_reel][8_feet]' } ).value },
				{ 'sku': 'TRX-FLC-S10', 'quantity': formData.find( function( item ){ return item.name === 'properties[film_reel][10_feet]' } ).value }
			);

			//update original audio
			if( $( '.input-original-audio-details' ).is( ':checked' ) ) {

				product.properties.data.value.actual_audio = true;

			}

    // } else if ( type === 'albums' ) {
    //       //TODO dead code remove
    //           for ( var i = 0; i < quantity; i++ ){
    //
    //             let quantity = formData.find( function( item ){ return item.name === 'properties[album][photos_' + (i + 1) + ']' }).value
    //             let extraQuantity = 0;
    //
    //             let originalQuantity = parseInt(quantity);
    //
    //             if ( quantity > 35 ) {
    //
    //               extraQuantity = quantity - 35;
    //               quantity = 35;
    //
    //               // product.properties.additional.estimate.total += (extraQuantity * 29);
    //
    //               // product.properties.data.value.quantity += 35;
    //               product.properties.data.value.quantity += (35 + extraQuantity);
    //               product.properties.data.value.extra_quantity += extraQuantity;
    //
    //       product.properties.data.value.line_items.push({
    //         "sku": "TRX-BLK-C01",
    //         "quantity": extraQuantity,
    //       });
    //
    //     //   product.final_line_price *= (extraQuantity * 29);
    //
    //           // console.log('HOLAAAAA');
    //           // console.log(product.final_line_price);
    //           //
    //           //           console.log('fotos extra en el carrito 2');
    //
    //       cartItems.push({
    //       id : parseInt( formData.find( function( item ){ return item.name === 'extra' } ).value ) || null,
    //       quantity : extraQuantity,
    //       properties : {
    //         'timeStamp' : {
    //           'date' : timeStamp,
    //                 'for' : 'Album Transfer ' + ( i + 1 )
    //         }
    //       }
    //     });
    //
    //             }
    //
    //
    //           var title = document.getElementsByName('properties[ album-' + i + ' ][ title ]');
    //           var rewind = document.getElementsByName('properties[ album-' + i + ' ][ rewind ]');
    //           var year = document.getElementsByName('properties[ album-' + i + ' ][ year ]');
    //           var month = document.getElementsByName('properties[ album-' + i + ' ][ month ]');
    //           var day = document.getElementsByName('properties[ album-' + i + ' ][ day ]');
    //
    //
    //
    //           if( $( year ).val() === '' && $( month ).val() === '' && $( day ).val() === '' ) {
    //
    //             product.properties.data.value.customizations.push({
    //               'title' : $( title ).val(),
    //               'quantity' : originalQuantity,
    //               'media_date' : null
    //             })
    //
    //           } else {
    //
    //             product.properties.data.value.customizations.push({
    //               'title' : $( title ).val(),
    //               'quantity' : originalQuantity,
    //               'media_date' : $( year ).val() + '/' + $( month ).val() + '/' + $( day ).val()
    //             })
    //
    //           }
    //
    //           }
    //           // console.log(formData.find( function( item ){ return item.name === 'properties[estimated-total]' } ).value);

    }

		// dvd upsell object ( only if quantity of dvd is greater than zero )
		var dvdID = formData.find( function( item ){ return item.name === 'upsellDVDID' } ).value;
		var dvdQuantity = formData.find( function( item ){ return item.name === 'properties[dvd][quantity]' } ).value;
		var dvdTotal = dvdQuantity;
		var dvdCost = formData.find( function( item ){ return item.name === 'properties[dvd-total]' } ).value;

		// usb upsell object ( only if quantity of usb is greater than zero )
		var usbQuantity = formData.find( function( item ){ return item.name === 'properties[usb][quantity]' } ).value;

		cartItems.push( product );

		if( additionalProduct ) {

			cartItems.push( additionalProduct );

		}

        /*
        if ( product.properties.data.value.line_items.length > 0 && ( type == 'album_scan' || type === 'albums' ) ) {

          let total = 0;

          const groupsAmount = product.properties.data.value.line_items.length;

          for( var i = 0; i < groupsAmount; i++ ) {

            total += product.properties.data.value.line_items[i].quantity;

          }

          console.log('total= ' + total);

          cartItems.push(
            {
              'quantity': total,

              'price': 29,
              'original_price': 29,
              'discounted_price': 29,
              'final_price': 29,

              'line_price': total * 29,
              'original_line_price': total * 29,
              'final_line_price': total * 29,

              'sku': 'TRX-BLK-C01',

              'image': "\/\/costco-staging.capture.com\/cdn\/shop\/products\/PhotoAlbum.jpg?v=1705523836",
              'product_title': 'Additional Album Photos'
            }
          );

        }
        */

        // console.log(cartItems);

		if( dvdID && dvdQuantity && dvdQuantity > 0 && type === 'album_scan' ) {

			for( var i = 0; i < quantity; i++ ) {


				cartItems.push({
					id : dvdID,
					quantity :  dvdQuantity,
					properties : {
						'timeStamp' : {
							'date' : timeStamp
						},
						'for' : 'Album Transfer ' + ( i + 1 )
					}
				});

			}
			product.properties.data.value.dvd_copies = dvdTotal;
			product.properties.upsells[ 'dvd' ].total = dvdCost;

			product.properties.data.value.dvd_options.theme = $( 'input[name="properties[dvd][theme]"]:checked' ).val();
			product.properties.data.value.dvd_options.music = $( 'input[name="properties[dvd][music]"]:checked' ).val() || 'MIS-BMU-NOM';

		} else if( dvdID && dvdQuantity && dvdQuantity > 0 && type === 'tapes' ) {


			for( var i = 0; i < quantity; i++ ) {
				// we push a new dvd line for each quantity of the product so they are on their own line_items
				cartItems.push({
					id : dvdID,
					quantity :  dvdQuantity,
					properties : {
						'timeStamp' : {
							'date' : timeStamp
						},
						'for' : 'Video Transfer ' + ( i + 1 )
					}
				});

			}

			product.properties.data.value.dvd_copies = dvdTotal;
			product.properties.upsells[ 'dvd' ].total = dvdCost;

			product.properties.data.value.dvd_options.theme = $( 'input[name="properties[dvd][theme]"]:checked' ).val();
			product.properties.data.value.dvd_options.music = $( 'input[name="properties[dvd][music]"]:checked' ).val() || 'MIS-BMU-NOM';

		} else if( dvdID && dvdQuantity && dvdQuantity > 0 && type === 'digital_media' ) {


			for( var i = 0; i < quantity; i++ ) {
				// we push a new dvd line for each quantity of the product so they are on their own line_items
				cartItems.push({
					id : dvdID,
					quantity :  dvdQuantity,
					properties : {
						'timeStamp' : {
							'date' : timeStamp
						},
						'for' : 'Digital Media Transfer ' + ( i + 1 )
					}
				});

			}

			product.properties.data.value.dvd_copies = dvdTotal;
			product.properties.upsells[ 'dvd' ].total = dvdCost;

			product.properties.data.value.dvd_options.theme = $( 'input[name="properties[dvd][theme]"]:checked' ).val();
			product.properties.data.value.dvd_options.music = $( 'input[name="properties[dvd][music]"]:checked' ).val() || 'MIS-BMU-NOM';

		} else if ( dvdID && dvdQuantity && dvdQuantity > 0 ) {

			cartItems.push({
				id : dvdID,
				quantity :  dvdQuantity,
				properties : {
					'timeStamp' : {
						'date' : timeStamp
					}
				}
			});

			product.properties.data.value.dvd_copies = dvdTotal;
			product.properties.upsells[ 'dvd' ].total = dvdCost;

			product.properties.data.value.dvd_options.theme = $( 'input[name="properties[dvd][theme]"]:checked' ).val();
			product.properties.data.value.dvd_options.music = $( 'input[name="properties[dvd][music]"]:checked' ).val() || 'MIS-BMU-NOM';

		}

		cartItems.reverse();

		// check if page is edit or new
		if( searchParams.has( 'edit' ) ) {

			$.ajax({
				url : '/cart.js',
				type : 'GET',
				dataType: 'json',
				success : function( res ) {

					// get main product values
					product = res.items.find( function( item ){ return item.key == searchParams.get( 'edit' ) });

					// get usb values for later
					var usbID = formData.find( function( item ){ return item.name === 'upsellUSBID' } ).value;
					var usbItem = res.items.find( function( item ){ return item.id == usbID } );

					// get all products that share timestamp
					var associatedItems = res.items.filter( function( item ){
						// usb doesn't have a timeStamp so we need to check for that
						if( item && item.properties && item.properties.timeStamp && item.properties.timeStamp.date && typeof item.properties.timeStamp.date !== 'undefined' ){
							return item.properties.timeStamp.date === product.properties.timeStamp.date
						}

					});

					// remove object, we'll loop through all teh associatedItems and set up the remove object for the update
					var dataRemove = {};

					for ( var i = 0; i < associatedItems.length; i++ ){

						dataRemove[ associatedItems[ i ].key ] =  0;

					}

					// check if the the usb item is already in the cart from the response, if it is we call the cart/update.js, if its not we call cart/add.js

					if( typeof usbItem == 'undefined' ){

						$.ajax({
							url : '/cart/add.js',
							type : 'POST',
							data: JSON.stringify({
								items : [
									{
										id : usbID,
										quantity : usbQuantity
									}
								]
							}),
							dataType : 'json',
							contentType: 'application/json',
							success : function( res ) {

								// clear the existing items ( this is just easier then trying to change the main item and then update dvds, since we can only update objects with properties one at time )
								$.ajax({
									url : '/cart/update.js',
									type : 'POST',
									async : false,
									data : JSON.stringify({
										updates : dataRemove
									}),
									dataType : 'json',
									contentType: 'application/json',
									success : function( res ) {


										// now that the exiting items are clear we can just run our cart add
										$.ajax({
											url : '/cart/add.js',
											type : 'POST',
											data: JSON.stringify({
												attributes : {
													auto_export : true
												},
												items : cartItems
											}),
											dataType : 'json',
											contentType: 'application/json',
											success : function( res ) {

												window.location = '/cart';

											},
											error : function( error ){

												alert( 'Sorry an error occurred.' );

											}
										});

									},
									error : function( err ){

										alert( 'Something went wrong.' );

									}
								});

							},
							error : function( err ) {


							}
						});

					} else {

						if( usbQuantity == 0 ){

							dataRemove[ usbItem.key ] =  0;

							// update if quantity is greater then zero
							$.ajax({
								url : '/cart/update.js',
								type : 'POST',
								data: JSON.stringify({
									updates: dataRemove
								}),
								dataType : 'json',
								contentType: 'application/json',
								success : function( res ) {

									// now that the exiting items are clear we can just run our cart add
									$.ajax({
										url : '/cart/add.js',
										type : 'POST',
										data: JSON.stringify({
											attributes : {
												auto_export : true
											},
											items : cartItems
										}),
										dataType : 'json',
										contentType: 'application/json',
										success : function( res ) {

											window.location = '/cart';

										},
										error : function( error ){

											alert( 'Sorry an error occurred.' );

										}
									});

								},
								error : function( err ) {

									console.log( err );
								}
							});

						} else {

							// update if quantity is greater then zero
							$.ajax({
								url : '/cart/change.js',
								type : 'POST',
								data: JSON.stringify({
									id : usbItem.key,
									quantity : usbQuantity
								}),
								dataType : 'json',
								contentType: 'application/json',
								success : function( res ) {

									// clear the existing items ( this is just easier then trying to change the main item and then update dvds, since we can only update objects with properties one at time )
									$.ajax({
										url : '/cart/update.js',
										type : 'POST',
										async : false,
										data : JSON.stringify({
											updates : dataRemove
										}),
										dataType : 'json',
										contentType: 'application/json',
										success : function( res ) {

											// now that the exiting items are clear we can just run our cart add
											$.ajax({
												url : '/cart/add.js',
												type : 'POST',
												data: JSON.stringify({
													attributes : {
														auto_export : true
													},
													items : cartItems
												}),
												dataType : 'json',
												contentType: 'application/json',
												success : function( res ) {

													window.location = '/cart';

												},
												error : function( error ){

													alert( 'Sorry an error occurred.' );

												}
											});

										},
										error : function( err ){

											alert( 'Something went wrong.' );

										}
									});

								},
								error : function( err ) {

									console.log( err );
								}
							});

						}

					}

				},
				error : function( err ) {

					console.log( err );
					console.log( 'last one');

				}
			});

		} else {

			//add usb item first, so it appears at the bottom of the list on checkout
			$.ajax({
				url : '/cart.js',
				type : 'GET',
				dataType: 'json',
				success : function( res ) {

					var usbID = formData.find( function( item ){ return item.name === 'upsellUSBID' } ).value;
					// update call for usbs so we can easily change the value globally

					// check if the the usb item is already in the cart from the response, if it is we call the cart/update.js, if its not we call cart/add.js
					var usbItem = res.items.find( function( item ){ return item.id == usbID } );

					if( typeof usbItem == 'undefined' ){

						$.ajax({
							url : '/cart/add.js',
							type : 'POST',
							data: JSON.stringify({
								items : [
									{
										id : usbID,
										quantity : usbQuantity
									}
								]
							}),
							dataType : 'json',
							contentType: 'application/json',
							success : function( res ) {

								$.ajax({
									url : '/cart/add.js',
									type : 'POST',
									data: JSON.stringify({
										attributes : {
											auto_export : true
										},
										items : cartItems
									}),
									dataType : 'json',
									contentType: 'application/json',
									success : function( res ) {

										window.location = '/cart';

									},
									error : function( error ){
										console.log( error )
										alert( 'Sorry an error occurred.' );

									}
								});

							},
							error : function( err ) {


							}
						});

					} else {

						if( usbQuantity == 0 ){

							var dataRemove = {};

							dataRemove[ usbItem.key ] =  0;
							// update if quantity is greater then zero
							$.ajax({
								url : '/cart/update.js',
								type : 'POST',
								data: JSON.stringify({
									updates: dataRemove
								}),
								dataType : 'json',
								contentType: 'application/json',
								success : function( res ) {

									$.ajax({
										url : '/cart/add.js',
										type : 'POST',
										data: JSON.stringify({
											attributes : {
												auto_export : true
											},
											items : cartItems
										}),
										dataType : 'json',
										contentType: 'application/json',
										success : function( res ) {

											window.location = '/cart';

										},
										error : function( error ){
											console.log( error )
											alert( 'Sorry an error occurred.' );

										}
									});

								},
								error : function( err ) {

									console.log( err );
								}
							});

						} else {

							// update if quantity is greater then zero
							$.ajax({
								url : '/cart/change.js',
								type : 'POST',
								data: JSON.stringify({
									id : usbItem.key,
									quantity : usbQuantity
								}),
								dataType : 'json',
								contentType: 'application/json',
								success : function( res ) {

									$.ajax({
										url : '/cart/add.js',
										type : 'POST',
										data: JSON.stringify({
											attributes : {
												auto_export : true
											},
											items : cartItems
										}),
										dataType : 'json',
										contentType: 'application/json',
										success : function( res ) {

											window.location = '/cart';

										},
										error : function( error ){
											console.log( error )
											alert( 'Sorry an error occurred.' );

										}
									});

								},
								error : function( err ) {

									console.log( err );
								}
							});

						}


					}

				},
				error : function( err ){


				}
			});

		}



	}
    var SaveSkip, type, target;
	$( document ).on( 'click', '.js-save-media-details', function() {
      $('.atc-popup').removeClass('hidden');
      SaveSkip = 'save';
      type = $( this ).data( 'type' );
		// var type = $( this ).data( 'type' );
		// if( validateForm() ) {
		// 	$( '.loader' ).toggleClass( 'active' );
		// 	submitTransfer( type );
		// 	var target = $( this ).data( 'toggleDrawer' );
		// 	$( target ).toggleClass( 'invisible' );
		// 	$( target ).find( '.js-edit-panel-inner' ).toggleClass( '-right-full' );
		// } else {
		// 	window.theme.functions.triggerAlert( 'Your item has an invalid date.', 'error' );
		// }

	});

	$( document ).on( 'click', '.js-skip-customization', function() {
      $('.atc-popup').removeClass('hidden');
      SaveSkip = 'skip';
      type = $( this ).data( 'type' );
      target = $( this ).data( 'toggleDrawer' );
		// var type = $( this ).data( 'type' );
		// if( ! searchParams.has( 'edit' ) ) {
		// 	$( '.js-title-input' ).val( '' );
		// 	$( '.title-input' ).val( '' );
		// 	$( '.js-date-input' ).each( function( index, input ) {
		// 		$( input ).val( '' );
		// 	});
		// 	$( '.tape-customizer-select-input' ).val( $( '.tape-customizer-select-input option:first' ).val() );
		// }
		// $( '.loader' ).toggleClass( 'active' );
		// submitTransfer( type );
	});
    $( document ).on( 'click', '.atc-popup #add-to-cart', function() {
      // console.log(type);
      if ($('.confirm-check').is(':checked')) {
        if (SaveSkip == 'skip') {
          if( ! searchParams.has( 'edit' ) ) {
            $( '.js-title-input' ).val( '' );
            $( '.title-input' ).val( '' );
            $( '.js-date-input' ).each( function( index, input ) {
              $( input ).val( '' );
            });
            $( '.tape-customizer-select-input' ).val( $( '.tape-customizer-select-input option:first' ).val() );
  		    }
          $( '.loader' ).toggleClass( 'active' );
          submitTransfer( type );
        } else {
          if( validateForm() ) {
            $( '.loader' ).toggleClass( 'active' );
            submitTransfer( type );
            $( target ).toggleClass( 'invisible' );
            $( target ).find( '.js-edit-panel-inner' ).toggleClass( '-right-full' );
          } else {
            window.theme.functions.triggerAlert( 'Your item has an invalid date.', 'error' );
          }
        }
      } else {
        alert('You must accept the return policy');
      }
	});
    $('.atc-close').on('click', function(){
    // console.log('close')
    $('.atc-popup').addClass('hidden');
  });
})();

